import React from "react";
import Page from "../components/Page";

// Import
import { useSelector } from "react-redux";
import RichText from "../components/RichText";

// Import for Display
import ResourcesSideNavBar from "../components/ResourcesSideNavBar";
import LoadingPage from "./LoadingPage";

function ResourcesPage() {
  const singleTypeSlug = "resource-hub";
  const { data } = useSelector((state) => state.cms);
  const cmsData = data[singleTypeSlug] && data[singleTypeSlug].attributes;

  // access our data and store it as collectionData
  const collectionSlug = "resources";
  const collectionData = data[collectionSlug];

  // Only load if data has returned.
  if (!cmsData || !collectionData) return <LoadingPage />;
  return (
    <Page data-wf-page="6351b24db1f7bb58b6a712a5" data-wf-site="634efd6b20b65bfc05be44e4">
      <div
        className="section wf-section"
        style={{
          height: "70vh",
          "background-image": `url(${
            cmsData.headerPhoto.data && cmsData.headerPhoto.data.attributes.url
          }`,
          "background-position": "50% 100%",
          "background-size": "cover",
        }}
      ></div>

      <div className="section wf-section">
        <div className="container resourcecontainer w-container">
          <div className="w-layout-grid gridresource">
            {/* Render Side Navbar */}
            <ResourcesSideNavBar data={collectionData} />

            {/* Description */}
            <div id="w-node-e2c1fd16-fe22-564d-1aa3-070edfe719f0-b6a712a5">
              <h1>{cmsData.title}</h1>
              <RichText text={cmsData.body} />
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
}

export default ResourcesPage;
